import { useColorMode } from "@chakra-ui/color-mode";
import { get } from "@chakra-ui/utils";
import { useTheme } from "./providers";
export function useChakra() {
  var {
    colorMode,
    toggleColorMode
  } = useColorMode();
  var theme = useTheme();
  return {
    colorMode,
    toggleColorMode,
    theme
  };
}
export function useToken(scale, token, fallback) {
  var theme = useTheme();
  var path = scale + "." + token;
  return get(theme, path, fallback != null ? fallback : token);
}
//# sourceMappingURL=hooks.js.map